import React from 'react'

import orangeSymbol from "./../../images/mb/orange_symbol.png";

const HeadingDescription = ({heading, description}) => {
  return (
    <div className="headingDescription">
      <div className="col-sm-5 headingDescription-title">
        <h2><img src={orangeSymbol} className="headingDescription-titleSymbol" alt />{heading}</h2>
      </div>
      <div className="col-sm-7 headingDescription-description" dangerouslySetInnerHTML={{__html: description}}></div>
    </div>
  )
}

export default HeadingDescription


// WEBPACK FOOTER //
// ./src/components/HeadingDescription/index.js